<template>
  <div>
    <div class="fullPageContent closed">
     <DashboardHeader 
         v-bind:showMobileRightMenu="false"
         v-bind:title="pageTitle" 
         v-bind:activeEl="activeEl">
      </DashboardHeader>
      <section class="allP wp1200 cuki-page">
        <Cookies></Cookies>
        <CookieSettings :showCookiesNotification="true" />
      </section>
    </div>
  </div>
</template>
<script>
import  DashboardHeader from './partials/DashboardHeader.vue';
import Cookies from "@/components/Cookies/Cookies";
import CookieSettings from "@/components/Cookies";

export default {
  data() {
    return {
      activeEl:null,
      pageTitle:this.$t("cookies.main_title")
    };
  },
  computed: {},  
  components: {
    Cookies,
    DashboardHeader,
    CookieSettings
  },
  mounted() {     
       this.$store.dispatch("app/loader", false);
  },
};
</script>
<style>
.vue-typer .custom.char.typed {
  color: #ffffff;
}
.vue-typer .custom.caret {
  display: none;
}

.cuki-page .cookiesBottom
{
	background-color:transparent;
	padding:0;
	position:static;
	margin-block-end:16px;
}
.cuki-page .cookiesBottom > p
{
	display:none;
}
.cuki-page .cookiesBottom > .buttonsCookies .join
{
	display:none;
}
.cuki-page .cuki-settings-toggle
{
	display:inline-flex;
	align-items:center;
	gap:12px;
	padding:8px 16px;
	border-radius:32px;
	background-color:#0297A7;
	cursor:pointer;
}
.cuki-page .cuki-settings-toggle:hover
{
	background-color:rgba(15,53,66,0.9);
}
.cuki-page .cuki-settings-toggle__title
{
	display:inline-block;
	color:#FFF;
}
.cuki-page .cookiesBottom .buttonsCookies a span.cuki-settings-toggle__icon
{
	color:#FFF;
	transition:0.2s ease-in-out;
}
.cuki-page .cuki-settings-toggle:hover .cuki-settings-toggle__icon
{
	rotate:45deg;
	transition:0.2s ease-in-out;
}
</style>